export const params = new URLSearchParams(window.location.search)

export const isStandalone = params.get('variant') === 'standalone'

export const version = params.get('version')

// android | cn_android | ios
export const platform = params.get('platform')

export const language = (() => {
  const langParam = params.get('language')
  if (langParam) return langParam
  const payload = params.get('payload')
  if (payload) {
    try {
      const payloadObj = JSON.parse(payload)
      if (payloadObj.language) return payloadObj.language
    } catch {
      //
    }
  }
  return 'en'
})()

export const region = params.get('region')

export const convertToken = params.get('convert_token')

export const audience = params.get('audience') as
  | null
  | 'seekrtech.forest'
  | 'seekrtech.sleeptown'
  | 'seekrtech.waterdo'
  | 'seekrtech.receipt'
  | 'upwardsware.forest'
  | 'upwardsware.waterdo'
  | 'upwardsware.receipt'
  | 'seekrtech.forest.next'
  | 'seekrtech.daily'

export type Audience = typeof audience

export const clientId = params.get('client_id')

export const redirectUri = params.get('redirect_uri') ?? ''

export const shouldLockServerSelect =
  params.get('should_lock_server_select') === 'true'

export const toBindingFlowIfLegacy = params.has('to_binding_flow_if_legacy')

export const disableSignup = params.has('disable_signup')

export const isInternalMode = params.get('__seekr_internal') === 'true'
